import { useMemo } from 'react';
import { useTheme } from '@/context/ThemeContext';
import { isDarkTheme } from '@/constants/Colors';
import { neutralColors } from '@/constants/neutralColors';

export default function useNeutralTheme() {
  const theme = useTheme();
  const colors = useMemo(() => neutralColors(theme.colors, isDarkTheme(theme.theme)), [theme.colors, theme.theme]);
  return { ...theme, colors };
}
